import React, { useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { Project } from '../types';
import { useInView } from '../hooks';
import styles from '../styles/ProjectCard.module.css';

interface ProjectCardProps {
  project: Project;
  index: number;
}

const ProjectCard: React.FC<ProjectCardProps> = ({ project, index }) => {
  const ref = useRef<HTMLDivElement>(null);
  const inView = useInView(ref, 0.08);
  const [hovered, setHovered] = useState(false);

  return (
    <div ref={ref} className={styles.cardOuter}>
      <Link
        to={`/work/${project.slug}`}
        className={`${styles.cardLink} ${styles.card} ${inView ? styles.visible : ''} ${hovered ? styles.hovered : ''}`}
        style={{ transitionDelay: `${index * 0.08}s` }}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
      {/* Image area */}
      <div className={styles.imgWrap} style={{ background: project.gradient }}>
        {project.video ? (
          <video
            src={project.video}
            className={`${styles.img} ${hovered ? styles.imgZoomed : ''}`}
            muted
            loop
            playsInline
            autoPlay
            aria-label={`${project.title} preview`}
          />
        ) : (
          <img
            src={project.img}
            alt={project.title}
            className={`${styles.img} ${hovered ? styles.imgZoomed : ''}`}
          />
        )}
        <span className={`${styles.emoji} ${hovered ? styles.emojiHovered : ''}`}>
          {project.emoji}
        </span>
      </div>

      {/* Text area */}
      <div className={styles.info}>
        <div className={styles.titleRow}>
          <span className={styles.title}>{project.title}</span>
          <span className={styles.dot}>•</span>
          <span className={styles.year}>{project.year}</span>
        </div>
        <p className={styles.desc}>{project.description}</p>
        <div className={styles.tags}>
          {project.tags.map((tag) => (
            <span
              key={tag}
              className={styles.tag}
              style={{
                color: project.accent,
                background: `${project.accent}18`,
                border: `1px solid ${project.accent}22`,
              }}
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
      </Link>
    </div>
  );
};

export default ProjectCard;
